/**
 * Renderer configuration helper.
 *
 * Returns one of two predefined configurations based on a feature-flag value.
 * The flag is expected to come from LaunchDarkly via `useFlagsCombination`.
 *
 * • `true`  → new renderer that supports layout-composition track reordering.
 * • `false` → legacy renderer where reordering must be skipped.
 */

export interface RendererConfig {
  /** Creatomate public token used to instantiate the Renderer. */
  rendererId: string;
  /**
   * When `true`, `Timeline.toJSON` will move layout-composition tracks
   * to the bottom (and `Timeline.fromJSON` will discard them on import).
   * The new renderer understands this track layout; the legacy one does not.
   */
  reorderLayoutCompositionTrackToBottom: boolean;
}

const NEW_RENDERER_CONFIG: RendererConfig = {
  rendererId: 'public-z3d8bimbdn24r8vnzflj5uqv',
  reorderLayoutCompositionTrackToBottom: true,
};

const LEGACY_RENDERER_CONFIG: RendererConfig = {
  rendererId: 'public-juuabbc8amz25dcfhribv3ss',
  reorderLayoutCompositionTrackToBottom: false,
};

/**
 * Resolve the renderer configuration based on the
 * `enableRendererLayoutReorder` feature flag.
 */
export function getRendererConfig(
  enableRendererLayoutReorder: boolean,
): RendererConfig {
  return enableRendererLayoutReorder
    ? NEW_RENDERER_CONFIG
    : LEGACY_RENDERER_CONFIG;
}
